import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import * as Yup from 'yup';
import FormCategory from './FormCategory';

export const CategorySchema = Yup.object().shape({
  name: Yup.string().required('Category name is required'),
});

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 5,
  p: 4,
};

function ModalCategory({ open, action, title, handleClose, onSave, category }) {
  const [initialValues, setInitialValues] = useState({
    id: null,
    name: '',
    state: true,
  });

  useEffect(() => {
    if (category) setInitialValues(category);
  }, [category]);

  const onSubmit = async (values, { setSubmitting, resetForm }) => {
    const result = {
      id: values.id,
      name: values.name,
      state: values.state,
    };
    onSave(action, result);
    setInitialValues({ id: null, name: '', state: true });
    setSubmitting(true);
    handleClose(true);
    resetForm();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {title}
        </Typography>
        <FormCategory
          onSubmit={onSubmit}
          initialValues={initialValues}
          categorySchema={CategorySchema}
        />
      </Box>
    </Modal>
  );
}

ModalCategory.defaultProps = {
  category: undefined,
};

ModalCategory.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  action: PropTypes.string.isRequired,
  category: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    state: PropTypes.bool.isRequired,
  }),
};

export default ModalCategory;
